import {
  StyledThankYou,
  StyledThankYouMain,
  StyledThankYouNote
} from './ThankYou.styled';

const ThankYou = () => {
  return (
    <StyledThankYou>
      <StyledThankYouMain>
        Thank you!
      </StyledThankYouMain>
      <StyledThankYouNote>
        Your purchase will be handled shortly
      </StyledThankYouNote>
    </StyledThankYou>
  );
};

export default ThankYou;
